<template>
  <b-modal
    id="delete-kpi-modal"
    title="Delete KPI"
    hide-footer
  >
    <h4 class="mb-2">
      Are you sure you want to delete this KPI?
    </h4>

    <div class="d-flex justify-content-around">
      <b-button
        class="mr-1"
        variant="danger"
        :disabled="deleting"
        @click="deleteHandler"
      >
        <b-spinner
          v-if="deleting"
          small
        />
        <span v-else>Yes, Delete</span>
      </b-button>
      <b-button
        variant="outline-primary"
        @click="$bvModal.hide('delete-kpi-modal')"
      >
        <span>No, keep kpi</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal, BButton, BSpinner,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import axiosIns from '@/libs/axios'

export default {
  components: {
    BModal,
    BSpinner,
    BButton,
  },
  props: {
    kpi: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const deleting = ref(false)
    const deleteHandler = async () => {
      try {
        deleting.value = true
        await axiosIns.delete(`/teams/kpis/${props.kpi.id}`)
        ctx.root.$bvModal.hide('delete-kpi-modal')
        ctx.emit('kpi-deleted')
      } finally {
        deleting.value = false
      }
    }

    return {
      deleting,
      deleteHandler,
    }
  },
}
</script>
